
import { ReportsDataContext } from "contexts/ReportsDataContext";
import { useContext } from "react";

// ==============================|| CONFIG - HOOKS  ||============================== //

const useReportsData = () => useContext(ReportsDataContext);

export default useReportsData;
